import React, { Component } from "react";
import { useNavigate } from "react-router-dom";

import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import WrappedUp from "../containers/WrappedUp";
import AccountList from "../components/AccountList";
import { getComptes } from "../../api/queries/comptes.queries";
import Fournisseurs from "../components/Fournisseurs";
import { notify } from "../generic";
import { compose, graphql } from "react-apollo";
import {
  toggleCompte,
  refreshComptes,
  forceRefreshCompte,
  deleteCompte
} from "../../api/queries/comptes.mutations";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import DetailsCompte from "./MyAccount/DetailsCompte";
import SecuriteCompte from "./MyAccount/SecuriteCompte";
import EntrepriseCompte from "./MyAccount/EntrepriseCompte";
import PlanExploitation from "../components/PlanExploitation/PlanExploitation";
import {
  addCategorie,
  addProduit,
  removeCategorie,
  removeProduit,
  renameCategorie,
  renameProduit
} from "../../api/queries/plan.mutations";
import { useAuthState } from "../Context";

function ConfigurationPage(props) {
  const navigate = useNavigate();
  const authContext = useAuthState(); //read user de
  const { userDetails = {} } = authContext;
  const {
    id: utilisateurId,
    login,
    email,
    token,
    entreprises = []
  } = userDetails;

  const _mutateToggleCompte = ({
    utilisateurId,
    identifiant,
    refetchAction
  }) => {
    try {
      return props
        .toggleCompte({
          variables: {
            utilisateurId,
            identifiant
          },
          refetchQueries: [
            {
              query: getComptes,
              variables: {
                utilisateurId
              }
            }
          ]
        })
        .then(({ data }) => {
          console.log("-----2");

          const { type, message, details } = data.toggleCompte;

          console.log("-----3");

          if (type === "success") {
            notify("success", message);
            refetchAction();
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      console.log({ error });
      notify("error", error.message);
    }
  };

  const _mutateRefreshComptes = utilisateurId => {
    try {
      return props
        .refreshComptes({
          variables: {
            utilisateurId
          },
          refetchQueries: [
            {
              query: getComptes,
              variables: {
                utilisateurId
              }
            }
          ]
        })
        .then(({ data }) => {
          const { type, message, details } = data.refreshComptes;

          if (type === "success") {
            notify("success", message);
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      console.log({ error });
      notify("error", error.message);
    }
  };

  const handleDeleteAccount = (identifiant, refetchAction) => {
    const confirmation = window.confirm(
      `Êtes-vous sûr(e) de vouloir supprimer cette connexion ? Les comptes de la même banque le seront aussi`
    );

    if (!confirmation) return;

    try {
      return props
        .deleteCompte({
          variables: {
            utilisateurId,
            identifiant
          },
          refetchQueries: [
            {
              query: getComptes,
              variables: {
                utilisateurId
              }
            }
          ]
        })
        .then(({ data }) => {
          const { type, message, details } = data.deleteCompte;

          if (type === "success") {
            refetchAction();
            notify("success", message);
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      console.log({ error });
      notify("error", error.message);
    }
  };

  const handleToggleAccount = ({
    utilisateurId,
    identifiant,
    refetchAction
  }) => {
    console.log({ utilisateurId, identifiant, refetchAction });

    _mutateToggleCompte({ utilisateurId, identifiant, refetchAction });
  };

  const test = name => alert(name);

  const params = useParams();

  const { identifier = "" } = params;

  const pages = [
    {
      title: "Configuration",
      identifier: "configuration",
      subItems: [
        {
          title: "Comptes bancaires",
          identifier: ""
        },
        {
          title: "Fournisseurs",
          identifier: "fournisseurs"
        },
        {
          title: "Plan d'exploitation",
          identifier: "plan-exploitation"
        }
      ]
    }
  ];

  let loadedModule = <Loader />;

  switch (identifier) {
    default:
      loadedModule = (
        <>
          <h1 className="dashboardTitle">Comptes synchronisés</h1>

          <p>
            Vous pouvez désactiver un compte à tout moment. Penge arrêtera de le
            comptabiliser dans ses calculs et cessera de récupérer les données
            quotidiennement.
            <br />
            Vous pourrez toujours activer/désactiver vos comptes synchronisés à
            tout moment.
          </p>
          <AccountList
            configurable
            names
            addButton
            checkedCondition="active"
            clickAction={handleToggleAccount}
            handleDeleteAccount={handleDeleteAccount}
          />
          <div className="col-md-6">
            <a
              onClick={() => _mutateRefreshComptes(utilisateurId)}
              className="btn btn-primary"
            >
              Forcer le rafraîchissement
            </a>
          </div>
        </>
      );
      break;
    case "fournisseurs":
      loadedModule = <Fournisseurs />;
      break;
    case "plan-exploitation":
      loadedModule = <PlanExploitation />;
      break;
    case "debug":
      loadedModule = <></>;
      break;
  }

  return (
    <WrappedUp>
      <ul id="insideMenu">
        {pages.map(menuParent => {
          return (
            <li>
              {" "}
              <span className="subTitle">{menuParent.title}</span>
              <ul className="subMenu">
                {menuParent.subItems.map(menuChild => {
                  return (
                    <li>
                      <a
                        href={`/configuration/${menuChild.identifier}`}
                        className={`${
                          menuChild.identifier === identifier ? "active" : ""
                        }`}
                      >
                        {menuChild.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>{" "}
      <div className="row clear pushedByMenu">{loadedModule}</div>
    </WrappedUp>
  );
}

export default compose(
  graphql(toggleCompte, {
    name: "toggleCompte"
  }),
  graphql(deleteCompte, {
    name: "deleteCompte"
  }),
  graphql(refreshComptes, {
    name: "refreshComptes"
  }),
  graphql(forceRefreshCompte, {
    name: "forceRefreshCompte"
  })
)(ConfigurationPage);
